import { useEffect } from "react";

const SITE = "ThinkStack";
const ORIGIN = process.env.REACT_APP_BACKEND_URL || "";
const DEFAULT_OG_IMAGE = "https://thinkstack.sg/og-image.jpg";

function setMeta(attr, key, content) {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

function setJsonLd(id, data) {
  let el = document.getElementById(id);
  if (data == null) {
    if (el) el.remove();
    return;
  }
  if (!el) {
    el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = id;
    document.head.appendChild(el);
  }
  el.textContent = JSON.stringify(data);
}

export function useSeo({ title, description, path = "", schema = null, image = null, canonical = null, robots = null, keywords = null }) {
  useEffect(() => {
    const cleanTitle = title ? title.replace(/\s*\|\s*ThinkStack\s*$/i, "") : "";
    const fullTitle = cleanTitle ? `${cleanTitle} | ${SITE}` : `${SITE} — Enterprise AI Transformation, Singapore`;
    const ogImage = image || DEFAULT_OG_IMAGE;
    document.title = fullTitle;
    setMeta("name", "description", description);
    setMeta("name", "keywords", keywords);
    setMeta("property", "og:title", fullTitle);
    setMeta("property", "og:description", description);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:site_name", SITE);
    setMeta("property", "og:image", ogImage);
    setMeta("name", "twitter:card", "summary_large_image");
    setMeta("name", "twitter:title", fullTitle);
    setMeta("name", "twitter:description", description);
    setMeta("name", "twitter:image", ogImage);
    const canonicalUrl = canonical || `${ORIGIN}${path}`;
    setLink("canonical", canonicalUrl);
    setMeta("property", "og:url", canonicalUrl);
    setMeta("name", "robots", robots || "index,follow");
    setJsonLd("page-schema", schema);

    setJsonLd("org-schema", {
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "ThinkStack",
      description:
        "Enterprise AI transformation partner headquartered in Singapore, redesigning business processes with consulting, implementation and AI.",
      url: ORIGIN,
      foundingLocation: "Singapore",
      areaServed: "Asia",
    });
  }, [title, description, path, schema, image, canonical, robots, keywords]);
}

export function breadcrumbSchema(items) {
  return {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.name,
      item: `${ORIGIN}${it.path}`,
    })),
  };
}
